import { useQuery } from '@tanstack/react-query'
import { generateMFASecret } from '~/services/mfaService'
import { QueryKeys } from '~/services/queryClient'

export const useGenerateMFASecret = () => {
  const { data, isSuccess, error } = useQuery({
    queryKey: QueryKeys.MfaCode,
    queryFn: generateMFASecret,
    meta: {
      persist: false
    }
  })
  return { data, isSuccess, error }
}
